import { FormControlLabel, IconButton } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import InputAdornment from '@material-ui/core/InputAdornment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import ClearIcon from '@material-ui/icons/Clear';
import { process as kendoProcess } from '@progress/kendo-data-query';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Grid, GridColumn, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { Splitter } from '@progress/kendo-react-layout';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as K2ACoreActions from '../../../actions/k2aCoreActions';
import * as ReportingActions from '../../../actions/reportingActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './SensorCountReport.module.css';

const initialDataState = {
    sort:   [],
    filter: [],
    group:  [{field: 'agentName'}],
    take:   20,
    skip:   0
};

const SensorCountReport = ({
    activeNavCompany,
    bobLoading,
    fetchClients,
    fetchSensorCountReport,
    sensorCountReport,
    setSensorCountReport
}) => {
    const [data, setData] = useState({dataResult: kendoProcess([], initialDataState), dataState: initialDataState});
    const [clientList, setClientList] = useState([]);
    const [filteredClientList, setFilteredClientList] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [pageable] = useState({pageSizes: true});
    const [take, setTake] = useState(20);
    const [workbookMode, setWorkbookMode] = useState(false);
    const [filterValue, setFilterValue] = useState('');
    const [allSelected, setAllSelected] = useState(false);

    useEffect(() => {
        return (() => {
            setSensorCountReport([]);
        });
    }, []);

    useEffect(() => {
        const init = async () => {
            const clients = await fetchClients(activeNavCompany.id, {pageSize: 500});
            setClientList(_.orderBy(clients, [(c) => c.name.toLowerCase()], ['asc']));
            setFilteredClientList(_.orderBy(clients, [(c) => c.name.toLowerCase()], ['asc']));
        };
        if (activeNavCompany && activeNavCompany.id) init();
    }, [activeNavCompany]);

    useEffect(() => {
        setData({dataResult: kendoProcess(sensorCountReport, data.dataState), dataState: data.dataState});
    }, [sensorCountReport]);

    useEffect(() => {
        if (!workbookMode) {
            initialDataState.filter = [];
            initialDataState.take = take;
            const dataResult = sensorCountReport && sensorCountReport !== null ? kendoProcess(sensorCountReport, initialDataState) : [];
            setData({dataResult: dataResult, dataState: initialDataState});
        }
    }, [workbookMode]);

    const handleToggle = value => () => {
        const currentIndex = selectedIds.indexOf(value);
        const newChecked = [...selectedIds];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setSelectedIds(newChecked);
        setAllSelected(newChecked.length === filteredClientList.length);
    };

    const onDataStateChange = event => {
        setTake(event.dataState.take);
        setData({dataResult: kendoProcess(sensorCountReport, event.dataState), dataState: event.dataState});
    };

    const onExpandChange = event => {
        const expandField = event.target.props.expandField || '';
        event.dataItem[expandField] = event.value;
        setData({...data});
    };

    let _export;
    const exportExcel = () => {
        if (data.dataResult && data.dataResult.data.length > 0) {
            _export.save();
        }
    };

    const handleWorkbookMode = () => {
        setWorkbookMode(!workbookMode);
    };

    const handleGenerate = async () => {
        if (selectedIds.length === 0) {
            return;
        }
        else {
            const ids = selectedIds.filter(id => id !== -1);
            await fetchSensorCountReport(activeNavCompany.id, ids);
        }
    };

    const getFileName = () => {
        const currentDate = moment().format('YYYY-MM-DD h:mm A');
        return `Sensor Count Report ${currentDate}.xlsx`;
    };

    const handleClientFilter = event => {
        setFilterValue(event.target.value.toLowerCase());
        setFilteredClientList(clientList.filter((c) => c.name.toLowerCase().includes(event.target.value.toLowerCase())));
    };

    const handleClearFilter = () => {
        setFilterValue('');
        setFilteredClientList(clientList);
    };

    const selectAllChanged = event => {
        setAllSelected(event.target.checked);
        if (event.target.checked) {
            // select all clients
            const newChecked = filteredClientList.map((c) => c.id);
            setSelectedIds(newChecked);
        }
        else {
            // deselect all clients
            setSelectedIds([]);
        }
    };

    return (
        <React.Fragment>
            <style>
                {
                    `.k-splitter-flex .k-pane-static {
                        flex-grow: 0;
                        flex-shrink: 0;
                        flex-basis: fit-content;
                    }
                    `
                }
            </style>
            <Splitter
                panes={[{size: '350px', resizable: false}, {resizable: false}]}
                orientation={'horizontal'}
            >
                <div style={{padding: '10px'}}>
                    <div className={classes.ListContainer}>
                        <div>
                            <div style={{fontSize: '1.2rem'}}>Clients</div>
                            <div style={{padding: '10px'}}>
                                <TextField
                                    variant="outlined"
                                    placeholder="Filter Clients"
                                    size="small"
                                    fullWidth
                                    value={filterValue}
                                    defaultValue={filterValue}
                                    onChange={handleClientFilter}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">
                                            <IconButton
                                                aria-label="clear filter"
                                                onClick={handleClearFilter}
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    }}
                                />
                            </div>
                            <div style={{marginLeft: '15px'}}>
                                <FormGroup row>
                                    <FormControlLabel
                                        classes={{
                                            label: classes.SelectAllCheckboxLabel
                                        }}
                                        control={
                                            <Checkbox
                                                checked={allSelected}
                                                onChange={selectAllChanged}
                                                name="SelectAllItems"
                                            />
                                        }
                                        label="Select All"
                                    />
                                </FormGroup>
                            </div>
                            <List className={classes.listRoot}>
                                {
                                    filteredClientList.map((c) => {
                                        const labelId = `checkbox-list-label-${c.id}`;
                                        return (
                                            <ListItem
                                                key={c.id}
                                                role={undefined}
                                                dense
                                                button
                                                onClick={handleToggle(c.id)}
                                            >
                                                <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={selectedIds.indexOf(c.id) !== -1}
                                                        tabIndex={-1}
                                                        disableRipple
                                                        inputProps={{ 'aria-labelledby': labelId }}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText
                                                    id={labelId}
                                                    primary={c.name}
                                                    disableTypography
                                                    classes={{
                                                        root: classes.listItemRoot
                                                    }}
                                                />
                                            </ListItem>
                                        );
                                    })
                                }
                            </List>
                        </div>
                        <div style={{paddingTop: '20px'}}>
                            <Button
                                className={classes.Button}
                                onClick={handleGenerate}
                                variant="outlined"
                                size="small"
                                disabled={bobLoading.includes('fetchSensorScoreReport')}
                            >
                                Generate
                            </Button>
                        </div>
                    </div>
                </div>
                <div style={{padding: '10px'}}>
                    <style>
                        { kendoGridInlineStyling }
                    </style>
                    <div className={classes.Table}>
                        <ExcelExport
                            data={sensorCountReport && sensorCountReport !== null ? kendoProcess(sensorCountReport, {group: data.dataState.group, filter: data.dataState.filter}).data : []}
                            ref={exporter => {_export = exporter;}}
                            collapsible
                            fileName={getFileName()}
                            filterable
                            group={data && data !== null ? data.dataState.group : []}
                        >
                            <Grid
                                className={classes.KendoGrid}
                                data={data.dataResult}
                                sortable={true}
                                groupable={true}
                                pageable={pageable}
                                filterable={workbookMode}
                                onDataStateChange={onDataStateChange}
                                onExpandChange={onExpandChange}
                                {...data.dataState}
                                expandField="expanded"
                            >
                                {
                                    bobLoading.includes('fetchSensorScoreReport') ?
                                        <GridNoRecords>
                                            Loading Sensor Count Report Data
                                        </GridNoRecords>
                                        :
                                        <GridNoRecords>
                                            No Report Data Found
                                        </GridNoRecords>
                                }
                                <GridToolbar>
                                    <div className={classes.wrapper}>
                                        <div className={classes.exportCell}>
                                            <Button
                                                className={classes.ButtonOutlinedMode}
                                                size="medium"
                                                variant="outlined"
                                                onClick={exportExcel}
                                            >
                                                Export
                                            </Button>
                                        </div>
                                        <div className={classes.workbookCell}>
                                            <Button
                                                className={workbookMode ? classes.ButtonContainedMode : classes.ButtonOutlinedMode}
                                                size="medium"
                                                variant={workbookMode ? 'contained' : 'outlined' }
                                                onClick={handleWorkbookMode}
                                            >
                                                Workbook Mode
                                            </Button>
                                        </div>
                                    </div>
                                </GridToolbar>
                                <GridColumn
                                    title={'Client Name'}
                                    field={'clientName'}
                                    width={350}
                                />
                                <GridColumn
                                    title={'Site Name'}
                                    field={'siteName'}
                                    width={350}
                                />
                                <GridColumn
                                    title={'Agent Name'}
                                    field={'agentName'}
                                    width={350}
                                />
                                <GridColumn
                                    title={'Sensor Count'}
                                    field={'sensorCount'}
                                    width={150}
                                />
                            </Grid>
                        </ExcelExport>
                    </div>
                </div>
            </Splitter>
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:  state.bob.activeNavCompany,
        bobLoading:        state.bob.bobLoading,
        sensorCountReport: state.reporting.sensorCountReport
    };
};

const mapDispatchToProps = ({
    ...BobActions,
    ...DashboardActions,
    ...K2ACoreActions,
    ...ReportingActions
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SensorCountReport));
